import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import LabelSelectButton from 'components/common/LabelSelectButton';
import {allowStateOption, dataOffsetOption} from 'data/option';
import {allowStateStatus} from 'data/status';
import {
  changeAllowStateBackOffice,
  changeAllowStateBackOfficeRequestApproval,
  registerReferralCode,
  updateRerralCode,
} from 'function/api';
import {IPermissionState} from 'interfaces/interface';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';
import {useFormatMsg} from 'utils/useFormatMsg';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};
const RegisterReferralCodeModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);

  const [state, setState] = useState<IPermissionState | ''>('');

  const [data, setData] = useState<any>();

  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    return () => {
      setState('');
      setCompleteModal(false);
    };
  }, []);
  return (
    <>
      <CommonModal closeModal={closeModal}>
        <BusinessModalContainer>
          <BusinessModalHeader>
            <DefaultText
              text={selectItem?.referralCode ? '수정' : '발급'}
              textStyle={{
                fontSize: minmax(40),
              }}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </BusinessModalHeader>

          <LabelInput
            type={'text'}
            labelText="코드"
            value={data?.code}
            setValue={(e: any) => setData((prev: any) => ({...prev, code: e}))}
          />

          <LabelInput
            type={'number'}
            labelText="만료시간"
            value={data?.expiredValue}
            setValue={(e: any) =>
              setData((prev: any) => ({...prev, expiredValue: e}))
            }
          />

          <LabelSelectButton
            value={data?.offset}
            setValue={(e: any) =>
              setData((prev: any) => ({...prev, offset: e}))
            }
            options={dataOffsetOption}
            buttonsWrapStyle={{justifyContent: 'center'}}
            buttonStyle={{width: '30%'}}
          />

          <DefaultButton
            text={selectItem?.referralCode ? '수정하기' : '발급하기'}
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: data ? colors.primary2 : colors.lighterGray,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={async () => {
              //

              let result;

              if (selectItem?.referralCode) {
                result = await updateRerralCode({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  ...data,
                  referralCodeUUID: selectItem?.referralCode?.uuid,
                });
              } else {
                result = await registerReferralCode({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  ...data,
                  ownerUUID: selectItem?.owner?.uuid,
                });
              }
              if (result) setCompleteModal(true);
            }}
          />
        </BusinessModalContainer>
      </CommonModal>
      {completeModal && (
        <CommonModal
          title={selectItem?.referralCode ? '수정 완료!' : '발급 완료!'}
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default RegisterReferralCodeModal;

const BusinessModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const BusinessModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
